<div class="page-content" [hidden]="timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title">{{'about_the_child_screen_2.page_title' |translate:childNameParam}}</h1>

     <p class="page-title" translate>
      {{ 'about_the_child_screen_2.please_review' }}
     </p>

     <p class="page-title" translate>
      {{ 'about_the_child_screen_2.you_are_creating' }}
     </p>

     
     <div class="div-table-row">
          <div class="div-table-col"  translate>{{'about_the_child_screen_2.child_name'}}</div>
          <div class="div-table-col2" translate><strong><span style="font-size: 1.375em;">{{childName}}</span></strong></div>
     </div>
     
     <div class="div-table-row">
         <div class="div-table-col" translate>{{ 'about_the_child_screen_2.born_on' }}</div>
         <div class="div-table-col2">{{childDOB | date: 'MMMM dd, yyyy':undefined:locale}}</div>
    </div>

     <div class="div-table-row">
         <div class="div-table-col" translate>{{ 'about_the_child_screen_2.sex' }}</div>
         <div class="div-table-col2">{{childGender}}</div>
    </div>

    <div class="div-table-row">
      <div class="div-table-col" translate>{{ 'about_the_child_screen_2.weight_at_birth' }}</div>
      <div class="div-table-col2">{{childWeight}}</div>
    </div>
    <div class="div-table-row" id="birthOrder">
      <div class="div-table-col" translate>{{ 'about_the_child_screen_2.birth_order' }}</div>
      <div class="div-table-col2"><span [translate]='childBirthOrder'></span></div>
    </div>
   <div class="div-table-row">
      <div class="div-table-col" translate>{{ 'about_the_child_screen_2.city_town_of_birth' }}</div>
      <div class="div-table-col2">{{childCityTown}}</div>
    </div>
    <div class="div-table-row">
      <div class="div-table-col" translate>{{ 'about_the_child_screen_2.place_of_birth' }}</div>
      <div class="div-table-col2"><span [translate]='placeOfBirth'></span></div>
    </div>
    <div class="div-table-row">
      <div class="div-table-col">
       <span [hidden]="data.aboutChild.birthPlaceType != 'HO'" translate>
              {{ 'about_the_child_screen_2.name_of_hospital' }}
      </span>
       <span [hidden]="data.aboutChild.birthPlaceType != 'BC'" translate>
              {{ 'about_the_child_screen_2.name_of_birthing_centre' }}
      </span>
       <span [hidden]="data.aboutChild.birthPlaceType != 'HM' && data.aboutChild.birthPlaceType != 'OT'" translate>
              {{ 'about_the_child_screen_2.street_number_name' }}
      </span>   
     </div>
     <div class="div-table-col2">{{nameOfBPlace}}</div>
     </div>
     <div class="div-table-row">
      <div class="div-table-col" translate>{{ 'about_the_child_screen_2.birth_attendant_type' }}</div>
      <div class="div-table-col2"><span [translate]='attendantType'></span></div>
     </div>
     <div class="div-table-row">
      <div class="div-table-col" translate>{{ 'about_the_child_screen_2.birth_attendant_name' }}</div>
      <div class="div-table-col2">{{attendantName}}</div>
     </div>
   

   <p class="page-title" [innerHTML]="'about_the_child_screen_2.sample_text1' | translate"></p>
   <p class="page-title" [innerHTML]="'about_the_child_screen_2.sample_text2' | translate"></p>
   <p class="page-title" [innerHTML]="'about_the_child_screen_2.sample_text3' | translate"></p>
   
   <span translate class="sr-only">{{ 'about_the_child_screen_2.sample_extract' }}</span>
   
   <div (click)="zoomChange();" title="{{(!zoomin? 'about_the_child_screen_2.zoom_in' : 'about_the_child_screen_2.zoom_out')  | translate }}">
      <img id="canvasPic" class="canvasPic" src="{{ 'about_the_child_screen_2.imageURL'| translate }}" 
      style="position: absolute;">
      <canvas #canvas width="658" height="131" style="cursor:pointer;" id="canvas" class="canvas"
       style="position: relative; cursor: pointer;">
            Your browser does not support the HTML5 canvas tag.
      </canvas>
   </div>
   

     <div class="btn-div">
          <div><button class="btn-next" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button></div>
     </div>

</div>